import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  screenSize: [0, 0],
  width: 0,
  height: 0,
};

export type ScreenSizeState = Readonly<typeof initialState>;

export const ScreenSizeSlice = createSlice({
  name: 'screenSizeSlice',
  initialState: initialState as ScreenSizeState,
  reducers: {
    setScreenSize(state, action) {
      return {
        ...state,
        screenSize: action.payload,
        width: action.payload[0],
        height: action.payload[1],
      };
    },
  },
});

export const { setScreenSize } = ScreenSizeSlice.actions;
export default ScreenSizeSlice.reducer;
